import React, { useEffect, useState, Fragment, useRef } from "react";
import useScripts from "../../../utils/UseScripts";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { addGraphicsToMap, showUpdationModal } from "../../../utils/Helpers";
import PageLoader from "../../../components/common/Loader/PageLoader";
import DivLoader from "../../../components/common/Loader/DivLoader";
import { useDirection } from "../../../components/DirectionContext";
import "../../../assets/styles/dataExtraction.css";
import "../../../assets/styles/map.css";
import * as query from "@arcgis/core/rest/query.js";
import { getLocalStorageItem } from "../../../utils/HelperFunctions";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Graphic from "@arcgis/core/Graphic";
import { calculateGraphicsExtent } from "../DataRequest/DataRequestUtils";
import Query from "@arcgis/core/rest/support/Query.js";
import Select from "react-select";
import CustomDropdownIndicator from "../../../components/common/CustomDropdownIndicator";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import parse from 'html-react-parser';
import Accordion from 'react-bootstrap/Accordion';
import { MdOutlineFileDownload, MdKeyboardBackspace } from "react-icons/md";
import { arcgisToGeoJSON } from "@terraformer/arcgis";
import shpwrite from '@mapbox/shp-write';
import fetchDataWithAuth from "../../../utils/api";
import {
    GenerateExcel,
    getFeaturesByFilter,
    convertToShapefile
} from "../../enviroportal/components/DataExport/DataExportUtils";
import esriConfig from "@arcgis/core/config.js";
import esriRequest from "@arcgis/core/request";
const DataRequestFeatureDetails = ({ id, mapview, approvedstatus, onCancel }) => {
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [requestDetails, setRequestDetails] = useState({});
    const [loading, showLoading] = useState(false);
    const [basemap, setBasemap] = useState(null);
    const [webmapId, setWebmapId] = useState(null);
    const { direction } = useDirection();
    const [status, setStatus] = useState({});
    const [rejectionReason, setRejectionReason] = useState("");
    const [dataRequestLayerUrl, setDataRequestLayerUrl] = useState(null);
    const [drFields, setdrFields] = useState(null);
    const [layers, setLayers] = useState([]);
    const [drawnArea, setDrawnarea] = useState(null);
    const [attachments, setAttachments] = useState([]);
    const [exportAllLayersChecked, setExportAllLayersChecked] = useState(true);
    const [selected, setSelected] = useState("Layers Data");
    const [File, setFile] = useState(null);
    const [buttonClicked, setButtonClicked] = useState(null);
    var allSelectedResults = [];
    const [selectedLayers, setSelectedLayers] = useState([]);
    var Email = getLocalStorageItem("Email");
    const [selectedStatus, setSelectedStatus] = useState(null);
    // const [portalToken, setPortalToken] = useState(null);
    const interceptorAdded = useRef(false);
    /**load the global config files required for this module */
    useScripts([`${process.env.PUBLIC_URL}/config/EnviroportalConfig.js`], () => {
        setScriptLoaded(true);
        // setPortalToken(window.portalToken);
        setBasemap(window.arcgis.basemap);
        setWebmapId(window.arcgis.webmapID);

        //globals
        setdrFields(window.dataRequestFieldMapping);
        setDataRequestLayerUrl(window.dataRequestFService);
    });

    useEffect(() => {
        return () => {
            if (mapview && mapview.graphics?.length) {
                mapview.graphics.removeAll();
            }
        };
    }, []);

    // useEffect(() => {
    //     if (!scriptLoaded || interceptorAdded.current || !dataRequestLayerUrl) return;

    //     if (portalToken) {
    //         const token = portalToken;

    //         esriConfig.request.interceptors.push({
    //             urls: [dataRequestLayerUrl],
    //             // use the BeforeInterceptorCallback to add token to query
    //             before: function (params) {
    //                 if (params && params.requestOptions) {
    //                     params.requestOptions.query = {
    //                         ...params.requestOptions.query,
    //                         token
    //                     };
    //                 }
    //             },
    //         });
    //     }

    //     interceptorAdded.current = true;
    // }, [scriptLoaded, portalToken, dataRequestLayerUrl]);

    const fetchMapLayers = async (mapServiceID) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/DataExtraction/mapLayers/${mapServiceID}`,
                {
                    method: "GET",
                }
            );
            if (!response.ok) {
                const errorText = await response.json();
                throw new Error(`${response.status}: ${errorText.message}`);
            }
            const data = await response.json();
            return { data, error: null };
        } catch (error) {
            return { data: null, error: error.message };
        }
    };

    const handleDownloadAttachment = async (attachmentId, attachmentName) => {
        const downloadUrl = `${dataRequestLayerUrl}/${id}/attachments/${attachmentId}`;

        try {
            // const response = await fetch(downloadUrl);
            const response = await esriRequest(downloadUrl, {
                responseType: "blob", // Important to get blob directly
                // No need to pass token if IdentityManager is managing auth
            });
            const blob = response.data;

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = attachmentName || "download.zip"; // Fallback name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(link.href); // Free up memory


            const extensionName = attachmentName.split('.').pop();
            let extension;
            if (extensionName === "xlsx") {
                extension = "Excel";
            }
            else if (extensionName === "kmz") {
                extension = extensionName.toUpperCase();
            }
            else if (extensionName === "zip" || extensionName === "shp") {
                extension = "Shapefile";
            }
            const payload = {
                //ID: 0,
                UserID: parseInt(localStorage.UserId) || 0,
                SearchModule: "Data Request",
                FeatureClassInfo: attachmentName.split('.')[0],
                ExportedFormat: extension,
                DownloadedDate: new Date().toISOString().slice(0, 16),
                SearchCriteria: ""
            }
            const apiResponse = await fetchDataWithAuth(
                `/PortalConfig/addDataExtrationlog`,
                "POST",
                navigate,
                t,
                payload
            );
            if (!apiResponse) {
                throw new Error(`Failed to log download: ${apiResponse.statusText}`);
            }
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    // Function to fetch attachments for a given feature ID
    const fetchFeatureAttachments = async (objectId) => {
        // const attachmentUrl = `${dataRequestLayerUrl}/${objectId}/attachments?f=json&token=${portalToken}`;

        // try {
        //     const response = await fetch(attachmentUrl, {
        //         method: "GET",
        //         headers: {
        //             "Content-Type": "application/json",
        //         },
        //     });

        //     if (!response.ok) {
        //         throw new Error(`HTTP error! Status: ${response.status}`);
        //     }

        //     const data = await response.json(); // Convert response to JSON
        const attachmentUrl = `${dataRequestLayerUrl}/${objectId}/attachments`;

        try {
            const response = await esriRequest(attachmentUrl, {
                query: {
                    f: "json"
                },
                responseType: "json"
                // No need to handle token if IdentityManager handles it
            });

            const data = response.data;

            if (data && data.attachmentInfos && data.attachmentInfos.length > 0) {
                // console.log("Attachments:", data.attachmentInfos); // Debugging output
                setAttachments(data.attachmentInfos);
            } else {
                console.warn("No attachments found.");
                setAttachments([]); // No attachments found
            }
        } catch (error) {
            console.error("Failed to fetch attachments:", error);
            setAttachments([]); // Ensure state is updated even if request fails
        }
    };

    useEffect(() => {
        const fetchDataRequestDetails = async () => {
            try {
                showLoading(true);
                /**use feature service */
                const requestsQuery = {
                    objectIds: [id],
                    outFields: ["*"],
                    returnGeometry: true,
                };
                query
                    .executeQueryJSON(dataRequestLayerUrl, requestsQuery)
                    .then(async (response) => {
                        const feature = response.features[0].attributes;
                        setRequestDetails(feature);
                        setStatus(feature.status);
                        setRejectionReason(feature[drFields.comments]);
                        showLoading(false);
                        mapview.graphics.removeAll();
                        addGraphicsToMap(mapview, [response.features[0]]);
                        try {
                            const graphicsExtent = calculateGraphicsExtent([
                                response.features[0],
                            ]);
                            if (graphicsExtent) {
                                mapview.goTo(graphicsExtent.expand(1.2)); // expand by 20% for better view
                            }

                            const geometry = response.features[0].geometry;
                            setDrawnarea(geometry);
                        } catch (error) {
                            console.log(error);
                        }
                        // Fetch attachment details
                        await fetchFeatureAttachments(id);
                    })
                    .catch((error) => {
                        showUpdationModal(t("dataRequestDetailsFetchFail"), "error");
                        showLoading(false);
                    });
            } catch (error) {
                showUpdationModal(t("dataRequestDetailsFetchFail"), "error");
                showLoading(false);
            }
        };
        if (mapview && dataRequestLayerUrl) {
            fetchDataRequestDetails();
        }
    }, [id, navigate, t, mapview, dataRequestLayerUrl]);

    const sendEmailToUser = async (result, generatedFiles, shapefile) => {
        try {
            showLoading(true);
            const formData = new FormData();
            if (status === "Approved") {
                formData.append("To", requestDetails.requestedby);
                formData.append("Status", status);
                formData.append("ID", result[drFields.requestID]);
                formData.append("Comments", rejectionReason || "");
                formData.append("file", generatedFiles.blob, generatedFiles.filename); // Append file blob and filename
                if (shapefile) {
                    formData.append("shapefile", shapefile, result.enMapServiceName + ".zip"); // Attach Shapefile
                    // formData.append("shapefile", shapefile, "Selected_Features.zip"); // Attach Shapefile
                }
            } else if (status === "Rejected") {
                formData.append("To", requestDetails.requestedby);
                formData.append("Status", status);
                formData.append("ID", result[drFields.requestID]);
                formData.append("File", null);
                formData.append("Comments", rejectionReason);
            }

            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/DataExtraction/NotifyDataRequestStatus`,
                    {
                        method: "POST",
                        body: formData,
                    }
                );
                // Handle the response if needed
                if (response.ok) {
                    showLoading(false);
                    if (status === "Approved") {
                        showUpdationModal(
                            parse(t("Request Approved", { requestNumber: id })),
                            "success",
                            navigate,
                            "/"
                        );
                    } else if (status === "Rejected") {
                        showUpdationModal(
                            parse(t("Request Rejected", { requestNumber: id })),
                            "success",
                            navigate,
                            "/"
                        );
                    }

                } else {
                    showUpdationModal(t("failedToUpdate"), "error");
                    showLoading(false);
                }
            } catch (error) {
                showLoading(false);
                throw new Error("Error sending the file via email");
            }
        } catch (error) {
            showLoading(false);
            throw new Error("Email sending failed");
        }
    };

    const updateDataRequest = async () => {
        try {

            if (status === "Approved" && selectedLayers.length === 0) {
                showUpdationModal(t("layerValidation"), "error");
                return;
            }

            showLoading(true);

            /**use feature service */
            const dataRequestGraphic = new Graphic({
                attributes: {
                    [drFields.requestID]: parseInt(id),
                    [drFields.status]: status,
                    [drFields.updatedBy]: getLocalStorageItem("username"),
                    [drFields.updatedDate]: new Date().getTime(),
                    [drFields.comments]: rejectionReason ? rejectionReason : null,
                },
            });
            var dataRequestLayer = new FeatureLayer({
                url: dataRequestLayerUrl,
            });
            const editsResult = await dataRequestLayer.applyEdits({
                updateFeatures: [dataRequestGraphic],
            });
            if (editsResult.updateFeatureResults.length > 0) {
                setButtonClicked(true);
            } else {
                throw new Error("Error applying edits");
            }
        } catch (error) {
            showUpdationModal(t("dataRequestUpdateFail"), "error");
            showLoading(false);
        }
    };

    // useEffect(() => {
    //   if (
    //     status &&
    //     status === "Rejected" &&
    //     requestDetails?.[drFields.comments]
    //   ) {
    //     setRejectionReason(requestDetails[drFields.comments]);
    //   }
    //   if (!status || status !== "Rejected") {
    //     setRejectionReason("");
    //   }
    // }, [status]);

    useEffect(() => {
        if (requestDetails?.mapserviceid) {
            const getMapLayers = async () => {
                try {
                    const result = await fetchMapLayers(requestDetails.mapserviceid);
                    if (result.error) {
                        throw new Error(result.error);
                    } else {
                        const mapLayers = result.data;
                        const layerIDsArray = requestDetails.layerids
                            .split(",")
                            .map((id) => parseInt(id.trim(), 10))
                            .filter((id) => !isNaN(id));
                        const matchedLayers = mapLayers.filter((layer) =>
                            layerIDsArray.includes(layer.id)
                        );
                        setLayers(matchedLayers);
                        setRequestDetails({ ...requestDetails, layers: matchedLayers });
                    }
                } catch (err) {
                    console.log("Failed to fetch map layers:", err);
                }
            };
            getMapLayers();
        }
    }, [requestDetails?.mapserviceid, requestDetails?.layerids]);

    const handleLayerSelection = (layerId, isSelected) => {
        if (isSelected) {
            setLayers((prevSelected) => [...prevSelected, layerId]);
            setSelectedLayers((prevSelected) => [...prevSelected, layerId]);
        } else {
            setLayers((prevSelected) => prevSelected.filter((id) => id !== layerId));
            setSelectedLayers((prevSelected) => prevSelected.filter((id) => id !== layerId));
        }
    };

    useEffect(() => {

        const fetchFeatures = async () => {
            let allSelectedResults = []; // Reset results each time
            let promises = [];

            //  Create an array of promises for querying layers
            const queryPromises = layers.map(async (layer) => {
                if (layers.includes(layer.id)) {
                    const featureLayer = new FeatureLayer({ url: layer.mapServiceUrl });
                    const query = new Query();
                    query.geometry = drawnArea;
                    query.spatialRelationship = "intersects";
                    query.outFields = ["*"];
                    query.returnGeometry = true;

                    /**apply time range if available */
                    const layerHasTabularData = (Object.keys(window.tabularDataLayers)).some(name => name === layer.layerName);
                    if (layerHasTabularData) {
                        let conditions = [];
                        const dateFieldName = window.tabularDataLayers[layer.layerName].dateField;
                        const _startDate = requestDetails.fromdate;
                        const _endDate = requestDetails.todate;
                        if (_startDate && !_endDate) {
                            conditions.push(`${dateFieldName} >= '${_startDate}'`);
                        }
                        if (_endDate && !_startDate) {
                            conditions.push(`${dateFieldName} <= '${_endDate}'`);
                        }
                        if (_startDate && _endDate) {
                            conditions.push(
                                `${dateFieldName} >= '${_startDate}' AND ${dateFieldName} <= '${_endDate}'`
                            );
                        }
                        const queryWhere = conditions.length
                            ? `(${conditions.join(" AND ")})`
                            : `1=1`;
                        query.where = queryWhere;
                    }

                    try {
                        const result = await featureLayer.queryFeatures(query);
                        if (result.features.length > 0) {
                            allSelectedResults.push(result); // Push feature
                        }
                    } catch (error) {
                        console.error("Error querying features from layer:", layer.mapServiceUrl, error);
                    }
                }
            });

            await Promise.all(queryPromises);

            //  Now execute logic only after all requests complete
            if (buttonClicked) {
                if (allSelectedResults.length > 0 && selectedStatus.label === "Approved") {
                    let ExcelFile = GenerateExcel(allSelectedResults, selected, exportAllLayersChecked);
                    setFile(ExcelFile[0]);
                    for (var i = 0; i < allSelectedResults.length; i++) {
                        const worker = new Worker(new URL("../../enviroportal/components/DataExport/geoJsonWorker.js", import.meta.url), { type: "module" });
                        const workerPromise = new Promise(async (resolve, reject) => {
                            worker.onmessage = (e) => {
                                if (e.data.success) {
                                    const geojson = e.data.geojson;
                                    // console.log(`Worker processed GeoJSON for layer :`, geojson);
                                    const normalizedFeatures = normalizeAttributes(geojson.features);
                                    resolve(normalizedFeatures);


                                } else {
                                    console.error("Error in worker:", e.data.error);
                                    reject(e.data.error);
                                }
                                worker.terminate();
                            };

                            worker.onerror = (error) => {
                                console.error("Worker error:", error);
                                reject(error);
                                worker.terminate();
                            };

                            var filteredFeatures = await getFeaturesByFilter(allSelectedResults[i].features)
                            worker.postMessage(filteredFeatures);
                        });

                        promises.push(workerPromise);
                    }


                    Promise.all(promises)
                        .then((normalizedFeatures) => {
                            convertToShapefile(normalizedFeatures, requestDetails.enmapservicename, async (shapefileBlob) => {
                                // convertToShapefile(normalizedFeatures, "Selected_Features", async (shapefileBlob) => {
                                // console.log("Shapefile Generated:", shapefileBlob);

                                if (ExcelFile[0] != null) {
                                    await sendEmailToUser({ ...requestDetails }, ExcelFile[0], shapefileBlob);
                                }
                            });
                        })
                        .catch(er => {
                            console.error("Error in shp export:", er);
                            throw new Error(er);
                        });
                }
                else if (selectedStatus.label === "Rejected") {
                    await sendEmailToUser({ ...requestDetails }, null, null);
                }
                else {
                    showLoading(false);
                }
            }
        };

        fetchFeatures();
    }, [layers, drawnArea, selected, exportAllLayersChecked, requestDetails, buttonClicked]);

    const normalizeAttributes = (features) => {
        let allKeys = new Set();

        // Collect all unique keys
        features.forEach(feature => {
            Object.keys(feature.properties).forEach(key => allKeys.add(key));
        });

        // Standardize attributes for all features
        return features.map(feature => {
            let newProperties = {};
            allKeys.forEach(key => {
                newProperties[key] = feature.properties[key] || null; // Fill missing attributes with null
            });
            return { ...feature, properties: newProperties };
        });
    };

    const setPurpose = (newPurpose) => {
        // Update the state using setRequestDetails
        setRequestDetails((prevState) => ({
            ...prevState,
            purpose: newPurpose,
        }));
    };

    useEffect(() => {
        if (window.dataRequestStatus.length > 0) {
            const matchedStatus = window.dataRequestStatus
                .map((drequest) => ({
                    value: drequest.id,
                    label: drequest.name,
                }))
                .find((statusOption) => statusOption.label === approvedstatus);

            setSelectedStatus(matchedStatus);
            setStatus(matchedStatus.label);
        }
    }, [approvedstatus]);

    return (
        <div id="data-review" className="data-review-blk" style={{ direction }
        }>
            {
                scriptLoaded ? (
                    <Fragment>
                        <div className="dem-sidebar" >
                            <div className="d-flex align-items-center gap-2 dataRevDetHead aa" >
                                <button className="datarequestbackbtn" onClick={onCancel} > <MdOutlineKeyboardBackspace size={25} /></button >
                                <h6 className="title px-0 mx-0" >
                                    {t("dataRequest")} {id && <strong>#{id} </strong>}
                                </h6>
                            </div>
                            {
                                requestDetails && Object.keys(requestDetails).length > 0 && (
                                    <>
                                        <div className="inputs" >
                                            <div className="form-group my-2" >
                                                <label htmlFor="mapService" className="mapServTitle mb-2 pe-2" >
                                                    {" "}
                                                    {t("mapService")}:
                                                </label>
                                                < span className="mapServTitle value" >
                                                    {
                                                        i18n.language === "en"
                                                            ? requestDetails[drFields.enMapServiceName]
                                                            : requestDetails[drFields.arMapServiceName]
                                                    }
                                                </span>
                                            </div>
                                            < div className="form-group mb-3" >
                                                <label htmlFor="mapLayer" className="mb-2" >
                                                    {" "}
                                                    {t("mapLayers")}
                                                </label>

                                                < ul className="mapLayers test" >
                                                    {
                                                        requestDetails.layers &&
                                                            requestDetails.layers.length > 0 ? (
                                                            requestDetails.layers.map((layer) => (
                                                                <li key={layer.id} className="button-group-item" >
                                                                    <button
                                                                        type="button"
                                                                        className={`btn toggle-btn ${layers.includes(layer.id) ||
                                                                            approvedstatus === "Approved"
                                                                            ? "active"
                                                                            : ""
                                                                            }`}
                                                                        onClick={() =>
                                                                            handleLayerSelection(
                                                                                layer.id,
                                                                                !layers.includes(layer.id)
                                                                            )
                                                                        }
                                                                        disabled
                                                                    >
                                                                        {layer.layerName}
                                                                    </button>
                                                                </li>
                                                            ))
                                                        ) : (
                                                            <p className="text-danger mb-0" style={{ fontSize: "12px" }}> {t("NoLayersFound")} </p>
                                                        )}
                                                </ul>
                                            </div>
                                            <div className="form-group mb-3">
                                                <label htmlFor="email" className="form-label mb-2">
                                                    {t("email")}: <span className="value">{requestDetails.requestedby}</span>
                                                </label>
                                            </div>
                                            < div className="form-group mb-3" >
                                                <label htmlFor="status" className="form-label mb-2">
                                                    {t("status")}: <span className="value">{status}</span>
                                                </label>

                                                {
                                                    status && status === "Rejected" && (
                                                        <div className="form-group mb-3 mt-3" >
                                                            <span className="text-danger" >* </span>{" "}
                                                            < label
                                                                htmlFor="rejectReason"
                                                                className="form-label mb-2"
                                                            >
                                                                {t("comment")}
                                                            </label>
                                                            < textarea
                                                                name="rejectReason"
                                                                value={rejectionReason}
                                                                className="form-control customtextarea"
                                                                onChange={(e) => setRejectionReason(e.target.value)
                                                                }
                                                            />
                                                            {
                                                                rejectionReason === "" && (
                                                                    <div className="text-danger" >
                                                                        {t("requiredField")}
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    )}
                                            </div>
                                            {/* < div className="form-group mb-3" >
                                                <label className="label mb-2" > {t("purpose")} </label>

                                                < textarea
                                                    rows={4}
                                                    cols={100}
                                                    className="form-control customtextarea"
                                                    value={requestDetails.purpose}
                                                    onChange={(e) => setPurpose(e.target.value)}
                                                    disabled
                                                />
                                            </div> */}
                                            {(requestDetails.fromdate || requestDetails.todate) &&
                                                <div className="d-flex w-100">
                                                    < label htmlFor="startDate" className="me-1 text-nowrap" >
                                                        {" "}
                                                        {t("Time Range")}:
                                                    </label>
                                                    < div className="d-flex justify-content-between row w-100" >
                                                        <div className="value form-group mb-3 col-6" >
                                                            {requestDetails.fromdate ?
                                                                new Date(requestDetails.fromdate).toLocaleDateString(
                                                                    "en-GB"
                                                                ) : ""
                                                            }
                                                            < span className="pe-2 ps-2" > {t("to")} </span>
                                                            {requestDetails.todate ?
                                                                new Date(requestDetails.todate).toLocaleDateString(
                                                                    "en-GB"
                                                                ) : ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>}
                                            {
                                                status && status === "Approved" && (
                                                    <div className="content-uploadedDoc dataRevFileAcco">
                                                        <Accordion className="uploadDocAccordion">
                                                            <Accordion.Item eventKey="0" className="accoCard">
                                                                <Accordion.Header className="accoCard-header">Download</Accordion.Header>
                                                                <Accordion.Body>
                                                                    <div className="uploadedFilesBlk --uploadedDoc inside">

                                                                        {/* <div className="uploadedFiles" >
                                                                    <div>
                                                                        <img src={`${process.env.PUBLIC_URL}/images/kmz-icon.svg`} alt="File Icon" />
                                                                    </div>
                                                                    <div>
                                                                        <div className="fileNamr">File name</div>
                                                                    </div>
                                                                    <div className="d-flex align-items-center fileSvgs">
                                                                        <MdOutlineFileDownload title={t("Download")} />
                                                                    </div>
                                                                </div>
                                                                <div className="uploadedFiles" >
                                                                    <div>
                                                                        <img src={`${process.env.PUBLIC_URL}/images/kmz-icon.svg`} alt="File Icon" />
                                                                    </div>
                                                                    <div>
                                                                        <div className="fileNamr">File name</div>
                                                                    </div>
                                                                    <div className="d-flex align-items-center fileSvgs">
                                                                        <MdOutlineFileDownload title={t("Download")} />
                                                                    </div>
                                                                </div> */}
                                                                        {attachments && attachments.length > 0 ? (
                                                                            attachments.map((attachment) => (
                                                                                <div className="uploadedFiles" key={attachment.id}>
                                                                                    <div>
                                                                                        <img src={`${process.env.PUBLIC_URL}/images/kmz-icon.svg`} alt="File Icon" />
                                                                                    </div>
                                                                                    <div>
                                                                                        <div className="fileNamr">{attachment.name}</div>
                                                                                    </div>
                                                                                    <div className="d-flex align-items-center fileSvgs">
                                                                                        <MdOutlineFileDownload
                                                                                            title={t("Download")}
                                                                                            onClick={() => handleDownloadAttachment(attachment.id, attachment.name)}
                                                                                            style={{ cursor: "pointer" }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <p>{t("No attachments found")}</p>
                                                                        )}
                                                                    </div>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>
                                                    </div>
                                                )}
                                        </div>

                                    </>
                                )}
                        </div>
                        {loading && <DivLoader />}
                    </Fragment>
                ) : (
                    <PageLoader />
                )}
            {/* </div> */}
        </div>
    );
};
export default DataRequestFeatureDetails;
